// Categoría de producto del catálogo en el idioma de la tienda. Puro.
import type { ProductCategoryEnum } from '@fiado/type-kit/bin/retailCatalog/enums/ProductCategoryEnum';

export const PRODUCT_CATEGORY_LABEL: Record<`${ProductCategoryEnum}`, string> = {
    PHONE: 'Teléfono',
    SIM: 'SIM',
    MODEM: 'Módem',
    ACCESSORY: 'Accesorio',
    BUNDLE: 'Kit',
};

type ProductCategoryKey = `${ProductCategoryEnum}`;

/** Categoría propia de los servicios (itemType SERVICE), aparte de la del catálogo. */
export const SERVICE_CATEGORY = 'SERVICE';
export const SERVICE_CATEGORY_LABEL = 'Servicio';

type ExtraCategoryKey = ProductCategoryKey | typeof SERVICE_CATEGORY;

const EXTRA_NOUN: Record<ExtraCategoryKey, [string, string]> = {
    PHONE: ['equipo', 'equipos'],
    SIM: ['SIM', 'SIMs'],
    ACCESSORY: ['accesorio', 'accesorios'],
    MODEM: ['módem', 'módems'],
    BUNDLE: ['kit', 'kits'],
    [SERVICE_CATEGORY]: ['servicio', 'servicios'],
};

/** «+1 accesorio» si las demás líneas son de una sola categoría; si se mezclan, solo «+N». */
export function extraItemsLabel(categories: readonly (ExtraCategoryKey | null)[]): string {
    const count = `+${String(categories.length)}`;
    const distinct = new Set(categories);
    const [only] = [...distinct];
    if (distinct.size !== 1 || only === null) return count;
    const [singular, plural] = EXTRA_NOUN[only];
    return `${count} ${categories.length === 1 ? singular : plural}`;
}
